import { CreateFlexibleBlockRequest, UpdateFlexibleBlockRequest } from '@yard/app/api';
import { IFlexibleBlockFormData } from '../models/yard-setup.model';

export const mapFlexibleBlockFormDataToCreateCommand = (
  data: IFlexibleBlockFormData,
  position?: { x: number; y: number },
) => {
  const command: CreateFlexibleBlockRequest = {
    name: data.name,
    equipmentTypes: data.equipmentTypes ?? [],
    acceptedLengths: data.acceptedLengths ?? [],
    position: {
      x: Math.round(position?.x ?? 0),
      y: Math.round(position?.y ?? 0),
      rotation: 0,
    },
  }

  return command
}

export const mapFlexibleBlockFormDataToUpdateCommand = (
  data: IFlexibleBlockFormData,
  id: string,
) => {
  const command: UpdateFlexibleBlockRequest = {
    id,
    name: data.name,
    acceptedLengths: data.acceptedLengths ?? [],
  }

  return command
}
